import { responsiveToCss as t } from "./utils.js";
function i(r, n) {
  return t("transition", r, n);
}
function s(r, n) {
  return t("transform", r, n);
}
export {
  s as transform,
  i as transition
};
